import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css'
import hamburger from '../Assets/hamburger.png'

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [scrolled])

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
  }

  return (
    <div className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className='navbar-left'>
        <h1 className='logo'>Antuan Furtch</h1>
      </div>
      <div className='navbar-middle'>
        <Link to='/' className='link'>Home</Link>
        <Link to='/about' className='link'>About</Link>
        <Link to='/projects' className='link'>Projects</Link>
        <Link to='/resume' className='link'>Resume</Link>
      </div>
      <div className='navbar-right'>
        <Link to='/contact' className='link' id='contact'>Contact</Link>
      </div>
      <button className='hamburger-btn' onClick={toggleMobileMenu}>
        <img src={hamburger} alt='menu' />
      </button>
      {mobileMenuOpen && (
        <div className='mobile-menu'>
          <Link to='/' className='mobile-link' onClick={closeMobileMenu}>Home</Link>
          <Link to='/about' className='mobile-link' onClick={closeMobileMenu}>About</Link>
          <Link to='/projects' className='mobile-link' onClick={closeMobileMenu}>Projects</Link>
          <Link to='/resume' className='mobile-link' onClick={closeMobileMenu}>Resume</Link>
          <Link to='/contact' className='mobile-link contact-mobile' onClick={closeMobileMenu}>Contact</Link>
        </div>
      )}
    </div>
  )
}
